/**
 * @param {string} url
 * @return {string}
 */
const getAbsUrl = (url) => {
  const publicHost = process.env.NEXT_PUBLIC_HOST || 'https://pdfedit.pro';

  return url.match(/^http[s]?:\/\//) ? url : publicHost + url;
};

export default getAbsUrl;
